import React from "react";
import { Input, Button, Modal } from "antd";
import { ExpandOutlined } from "@ant-design/icons";

const { TextArea } = Input;

interface FullScreenTextAreaProps {
  value?: string;
  onChange?: (value: string) => void; // مهم: نوع onChange مشخص شود
}

const FullScreenTextAreaForm: React.FC<FullScreenTextAreaProps> = ({ value = "", onChange }) => {
  const [isFullScreen, setIsFullScreen] = React.useState(false);

  return (
    <>
      <div style={{ position: "relative" }}>
        <TextArea
          rows={4}
            placeholder="توضیحات خود را اینجا وارد کنید..."
          value={value}
          onChange={(e) => onChange?.(e.target.value)}
          style={{ width: "100%", paddingRight: "4px" }}
        />
        <Button
          type="text"
          onClick={() => setIsFullScreen(true)}
          style={{
            position: "absolute",
            top: 4,
            left: 4,
            padding: 0,
            height: 24,
            width: 24,
            minWidth: 0,
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
          }}
          icon={<ExpandOutlined style={{ fontSize: 16, color: "#000000ff" }} />}
        />
      </div>

      <Modal
        title="توضیحات"
        open={isFullScreen}
        onCancel={() => setIsFullScreen(false)}
        footer={[
          <Button key="close" type="primary" onClick={() => setIsFullScreen(false)}>
            بستن
          </Button>,
        ]}
        width="100%"
        bodyStyle={{ padding: 0 }}
      >
        <TextArea
          autoSize={{ minRows: 20, maxRows: 30 }}
          value={value}
          onChange={(e) => onChange?.(e.target.value)}
          style={{ width: "100%", height: "100%", padding: "12px" }}
        />
      </Modal>
    </>
  );
};

export default FullScreenTextAreaForm;
